import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash && hash.length > 1) {
            const id = hash.replace('#', '');
            const el = document.getElementById(id);
            if (el) {
                window.requestAnimationFrame(() => {
                    document.documentElement.scrollLeft = 0;
                    document.body.scrollLeft = 0;
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
                return;
            }
        }
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        if (typeof document !== 'undefined') {
            document.documentElement.scrollLeft = 0;
            document.body.scrollLeft = 0;
        }
    }, [pathname, hash]);

    return null;
}

